// extracted by mini-css-extract-plugin
export default {"listWrapper":"ArticlesList-module__listWrapper--tm3t7"};